var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.3332 9.99996C18.3332 14.6033 14.6023 18.3333 9.99984 18.3333C5.39734 18.3333 1.6665 14.6033 1.6665 9.99996C1.6665 5.39829 5.39734 1.66663 9.99984 1.66663C14.6023 1.66663 18.3332 5.39829 18.3332 9.99996Z",
    fill: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9779 13.1787C12.8687 13.1787 12.7587 13.1504 12.6579 13.0912L9.3862 11.1396C9.19786 11.0262 9.08203 10.8221 9.08203 10.6021V6.39624C9.08203 6.05124 9.36203 5.77124 9.70703 5.77124C10.052 5.77124 10.332 6.05124 10.332 6.39624V10.2471L13.2987 12.0162C13.5945 12.1937 13.692 12.5771 13.5154 12.8737C13.3979 13.0696 13.1904 13.1787 12.9779 13.1787Z",
    fill: "#302E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCircle);
export default __webpack_public_path__ + "static/media/Time_Circle.eea90a29174cbd656b5296855cf18cc3.svg";
export { ForwardRef as ReactComponent };